<section *ngIf="isValidData" class="dialog-content padding-40 text-align-center">
	<section>
		<img ada-decorative [remote-src]="imagePath" onerror="this.style.display = 'none'" />
		<p class="text-18-bold padding-top-10" dcrHTMLKey="COMPARE_MODEL_TITLE">Before you can compare these portfolios they will need to be adjusted.</p>
	</section>
	<section class="padding-top-30">
		<p dcrHTMLKey="COMPARE_MODEL_DESCRIPTION">
			Several portfolios you selected contain unsupported holdings. You will need to adjust each portfolios in our Portfolio Editor before you can compare them.
		</p>
		<p dcrHTMLKey="COMPARE_MODEL_CHOOSE" class="padding-top-20">Please choose one portfolio to modify first.</p>
	</section>
	<section class="grid text-14-bold padding-top-30">
		<section class="col-24 portfolios" *ngFor="let umaPortfolio of dialogData.umaPortfolio; let i = index">
			<button class="portfolio" (click)="updateSelect(umaPortfolio)" [class.selected]="umaPortfolio === selectedPortfolio">
				{{ umaPortfolio }}
			</button>
		</section>
		<div class="row padding-top-60">
			<section class="col-12">
				<button dz-button color="secondary" class="pull-left cancel" (click)="onCancelClick()" dcrHTMLKey="CANCEL_LABEL" track-event="model-compare:button:cancel">
					Cancel
				</button>
			</section>
			<section class="col-12">
				<button dz-button class="pull-right continue" (click)="onContinueClick()" dcrHTMLKey="CONTINUE_LABEL" track-event="model-compare:button:continue">Continue</button>
			</section>
		</div>
	</section>
</section>
